import { useState } from 'react';
import { App, Button, Modal, Space, Table, Tag } from 'antd';
export default function KeyBatchBar({ ids, onSelectionChange, execute, onDone, getContainer }) {
  const { message } = App.useApp(); const [action, setAction] = useState(''); const [busy, setBusy] = useState(false); const [results, setResults] = useState(null);
  const submit = async () => {
    setBusy(true);
    try {
      const response = await execute(action, ids);
      if (response.code !== 0) throw new Error(response.message || '批量操作失败');
      const data = response.data; setResults(data.results); onSelectionChange(data.results.filter(row => !row.success).map(row => row.id));
      message.info(`成功 ${data.succeeded} 项，失败 ${data.failed} 项`); setAction(''); onDone();
    } catch (error) { message.error(error.response?.data?.message || error.message); } finally { setBusy(false); }
  };
  return <>
    <Space wrap style={{ marginBottom: 12 }}>
      <span>已选择 {ids.length} 个 Key（可跨页，单次最多 100 个）</span>
      <Button disabled={!ids.length || ids.length > 100} onClick={() => setAction('enable')}>批量启用</Button>
      <Button disabled={!ids.length || ids.length > 100} onClick={() => setAction('disable')}>批量禁用</Button>
      <Button danger disabled={!ids.length || ids.length > 100} onClick={() => setAction('delete')}>批量删除</Button>
      <Button disabled={!ids.length} onClick={() => onSelectionChange([])}>清空选择</Button>
    </Space>
    <Modal open={!!action} title="确认批量操作" onCancel={() => { if (!busy) setAction(''); }} onOk={submit} confirmLoading={busy} getContainer={getContainer}>
      即将{action === 'delete' ? '删除' : action === 'enable' ? '启用' : '禁用'}所选 {ids.length} 个 Key。仅操作明确选择的 ID。删除不能撤销；默认 Key、存在预扣或待结算任务的 Key 会保留，并逐项显示结果。
    </Modal>
    <Modal open={!!results} title="批量操作结果" footer={null} onCancel={() => setResults(null)} getContainer={getContainer} width={700}>
      <Table rowKey="id" size="small" dataSource={results || []} columns={[
        { title: 'Key ID', dataIndex: 'id' },
        { title: '结果', dataIndex: 'success', render: success => <Tag color={success ? 'green' : 'red'}>{success ? '成功' : '失败'}</Tag> },
        { title: '说明', dataIndex: 'message', render: text => text || '已完成' },
      ]} />
    </Modal>
  </>;
}
